<template>
  <section id="register" class="py-16 bg-primary relative overflow-hidden">
    <div class="absolute inset-0 opacity-10">
      <div class="absolute inset-0 bg-cover bg-center" :style="{ backgroundImage: `url(${bgImage})` }"></div>
    </div>
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div class="max-w-3xl mx-auto text-center">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-white">立即注册，开启职业提升之旅</h2>
        <p class="mt-4 text-white/90 text-lg">注册即可享受课程优惠、职位推荐、证书服务等多重福利</p>
        <div class="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <button @click="$emit('open-register-modal')" class="px-8 py-3 bg-white text-primary font-medium rounded-lg hover:shadow-lg transition-custom">
            快速注册
          </button>
          <button class="px-8 py-3 bg-transparent text-white border border-white rounded-lg hover:bg-white/10 transition-custom">
            了解更多
          </button>
        </div>
        <p class="mt-6 text-white/70 text-sm">已有账号？<a href="#" @click="$emit('open-login-modal')" class="text-white underline hover:text-white/90">立即登录</a></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RegisterSection',
  data() {
    return {
      bgImage: require('@/assets/1048-1920x1080.jpg')
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 